import { useEffect, useState } from "react";
import Modal from "react-modal";

import Button from "../../Button";

import * as S from "./styles";
import { useDataList } from "hooks/useDataList";
import { IClient } from "interfaces/Client";
import { AutoComplete } from "components/Autocomplete";
import { updateSubClientService } from "services/SubClientServices";
import { ISuperficialClient } from "interfaces/SubClient";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  subClient:ISuperficialClient
};

export function TransferSubClientModal({ isOpen, onRequestClose, subClient }: Props) {
  const [client, setClient] =  useState<IClient>();
  const [sending, setSending] =  useState<boolean>(false);
  const clientsData = useDataList<IClient>({
    queryKey: 'listAllClients',
    route: 'clients',
    filter: {
      notPage: true,
    }
  }).data;


  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentElement={(props, children) => (
        <S.ModalContent {...props}>{children}</S.ModalContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ModalOverlay {...props}>{contentElement}</S.ModalOverlay>
      )}
    >
      <S.Wrapper>
        <S.Column>
          <S.FormTitle>Transferência de subcliente</S.FormTitle>

          <S.FilterForm>
            <AutoComplete
              id="client"
              label="Selecione um cliente"
              isMulti={false}
              isSearchable
              placeholder="Selecione um cliente"
              noOptionsMessage={() => 'Nenhum cliente encontrado'}
              options={clientsData?.items ?? []}
              getOptionLabel={(option) => option.name}
              onChange={(selected) => {
                if (!selected) {
                  setClient({} as IClient);
                }

                if (selected) {
                  setClient(selected as IClient);
                }
              }}
            />
            <div>
              <div>
                <p className="title">O subcliente</p>
                <h4 className="subtitle">{subClient.name}</h4>
              </div>
              <div>
                <p className="title">Será transferido do cliente</p>
                <h4 className="subtitle">{subClient.client.name}</h4>
              </div>
              <div>
                <p className="title">Para o cliente</p>
                <h4 className="subtitle">{client?.name ?? '*A escolher*'}</h4>
              </div>
              <Button
                title={"Transferir"}
                type="button"
                onClick={()=>{
                  setSending(true)
                  updateSubClientService({
                    superficialClient:{
                      id: subClient.id,
                      client:{
                        id:client?.id
                      }
                    }
                  }).finally(()=>{
                    setSending(false)
                    window.location.reload();
                  })
                }}
                disabled={!client || sending}
              />
            </div>
            </S.FilterForm>
        </S.Column>
      </S.Wrapper>
    </Modal>
  );
}
